/* @flow weak */
function leftpad(str, padding, length) {
  const padded = padding.repeat(length) + str;

  return padded.slice(padded.length - length);
}

export default function formatMediaTime(seconds, showHours) {
  let time = '';

  const hours = parseInt(seconds / 3600, 10);
  if (showHours) {
    time += leftpad(hours.toString(), '0', 2) + ':';
  }

  const minutes = parseInt((seconds % 3600) / 60, 10);
  time += leftpad(minutes.toString(), '0', 2) + ':';

  const secondsInt = parseInt(seconds % 60, 10);
  time += leftpad(secondsInt.toString(), '0', 2);

  return time;
}
